<template>
    <div>
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <v-tab
                    href="#tab-data"
            >
                Agent Data
            </v-tab>
            <v-tab
                    href="#tab-clients"
            >
                Clients
            </v-tab>
        </v-tabs>

        <v-tabs-items
                v-model="model"
                class="elevation-10"
        >
            <v-tab-item
                    value="tab-data"
            >
                <v-card flat>
                    <DataComponent v-if="model == 'tab-data'" :id="id"></DataComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-clients"
            >
                <v-card flat>
                    <ClientsComponent v-if="model == 'tab-clients'" :id="id"></ClientsComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
    import DataComponent from './view/DataComponent';
    import ClientsComponent from './view/ClientsComponent';

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-data'
            }
        },
        created () {
            this.setSectionTitle();
        },
        methods: {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Agents detail.'
                });
            },
        },
        components: {
            DataComponent,
            ClientsComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/agents/DetailComponent.vue